export default __webpack_public_path__ + "static/media/three-image.87fb745d.png";